import styled from 'styled-components';

const InputContainer = styled.div `
  margin-left: 16px;

  & > div > div {
    margin-top: 0 !important;
  }
`;

export { InputContainer };
